import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  page: string | null;
  month: string;
  perPage?: string | null;
};

const donwloadReportBirthdaysToExcel = async ({ page, month, perPage }: Props) => {
  const pageParams = `page=${page || 1}&month=${month}&perPage=${perPage}`;

  const response = await httpRequest.get(
    `/export-patients-birthdays-in-xlsx?${pageParams}`,
    {
      responseType: "blob",
    }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `report-patients-birthdays.xlsx`);
  document.body.appendChild(link);
  link.click();
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  } else {
    document.body.removeChild(link);
  }
};

export function useDownloadReportBirthdaysToExcelMutation(props: Props) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => donwloadReportBirthdaysToExcel(props),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["report-birthdays-download-excel", props.page],
      });
    },
  });
}
